import dynamic from 'next/dynamic';

const GuaranteeReturnsListContent = dynamic(() =>
  import('./GuaranteeReturnsListContent/GuaranteeReturnsListContent')
);

export { GuaranteeReturnsListContent };
